import type React from 'react';

import type { IconProps } from 'types/icon';

const Search: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M14.4161 8.38809C14.4161 5.05881 11.7174 2.36008 8.38809 2.36008C5.05881 2.36008 2.36008 5.05881 2.36008 8.38809C2.36008 11.7174 5.05881 14.4161 8.38809 14.4161C11.7174 14.4161 14.4161 11.7174 14.4161 8.38809ZM15.2762 8.38809C15.2762 12.1922 12.1922 15.2762 8.38809 15.2762C4.584 15.2762 1.5 12.1922 1.5 8.38809C1.5 4.584 4.584 1.5 8.38809 1.5C12.1922 1.5 15.2762 4.584 15.2762 8.38809Z"
        fill={color}
      />
      <path
        d="M14.5422 14.5422C14.71 14.3743 14.9821 14.3743 15.15 14.5422L18.379 17.7712C18.5469 17.9391 18.5469 18.2111 18.379 18.379C18.2111 18.5469 17.9391 18.5469 17.7712 18.379L14.5422 15.15C14.3743 14.9821 14.3743 14.71 14.5422 14.5422Z"
        fill={color}
      />
    </svg>
  );
};

export default Search;
